/** '2026-10-03' → '3 okt 2026' (of '3 Oct 2026'). */
export function datumKort(iso: string, taal: string): string {
  const [j, m, d] = iso.split('-').map(Number);
  return new Intl.DateTimeFormat(taal === 'en' ? 'en-GB' : 'nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }).format(
    new Date(j, m - 1, d),
  );
}
